import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromDocuments from './+state/documents.reducer';
import { DocumentsEffects } from './+state/documents.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromDocuments.DOCUMENTS_FEATURE_KEY,
      fromDocuments.documentsReducer
    ),
    EffectsModule.forFeature([DocumentsEffects]),
  ],
})
export class SharedDataAccessDocumentsModule {}
